import React from 'react';

/**
 * Utility to only call callback if key pressed is enter or space when focused on an
 * interactive element
 */
export const handleInteractiveKeydown =
  (cb: React.KeyboardEventHandler): React.KeyboardEventHandler =>
  e => {
    if (e.key === 'Enter' || e.key === ' ') cb(e);
  };
